import API from "@utils/plugins/API";

const GearActivationMethod = {
  all: (params) => {
    return API.get("gear-activation-methods", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("gear-activation-methods", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`gear-activation-methods/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`gear-activation-methods/${id}`);
  },
  destroy: (id) => {
    return API.delete(`gear-activation-methods/${id}`);
  },
};

export default GearActivationMethod;
